import styled from "@emotion/styled";
import { Card, CardContent, Theme } from "@mui/material";

export const StyledCard = styled(Card)<{theme: Theme}>((props) => ({
  display: "inline-block",
  border: "rgba(0,0,0,0.5) solid 1px",
  width: "100%",
  borderRadius: "10px",
}));

export const StyledCardContent = styled(CardContent)<{theme: Theme}>((props) => ({
    paddingTop: props.theme.spacing(.5),
    paddingBottom: props.theme.spacing(.5) + '!important',
}));